/**
 * Sportconnect — Header scroll Web Component
 * Snazzy Digital Agency
 *
 * Bascule le header de transparent à solid quand on dépasse le seuil
 * de scroll. Si transparent_on_hero=false, le header est solid d'emblée
 * (le Web Component ne fait alors rien).
 *
 * prefers-reduced-motion : on garde le bascule (instantané) car
 * désactiver complètement réduirait la lisibilité du texte au scroll.
 */

class SCHeaderScroll extends HTMLElement {
  connectedCallback() {
    this.header = this.querySelector('.sc-header');
    if (!this.header) return;

    this.transparent = this.dataset.transparent === 'true';
    this.threshold = parseInt(this.dataset.threshold, 10) || 32;

    if (!this.transparent) {
      // Pas de transparence demandée : header solid en permanence, rien à faire
      this.header.dataset.solid = 'true';
      return;
    }

    this.onScroll = this.onScroll.bind(this);
    this.onScroll();
    window.addEventListener('scroll', this.onScroll, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    const solid = window.scrollY > this.threshold;
    if (this.header.dataset.solid !== String(solid)) {
      this.header.dataset.solid = String(solid);
    }
  }
}

if (!customElements.get('sc-header-scroll')) {
  customElements.define('sc-header-scroll', SCHeaderScroll);
}
